import { render, staticRenderFns } from "./TaggingPresenterComponent.vue?vue&type=template&id=071fe6aa&"
var script = {}
import style0 from "./TaggingPresenterComponent.vue?vue&type=style&index=0&id=071fe6aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports